// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "respweb/static/styles/" + "vendors" + "." + "f5d7e1f1" + ".css";
};